export class EvadocEvaluadorDto {
    evaluador: number;
    docente: number;
    periodo: number;
}
